<template>
  <div>
    <div class="py-3 bg-secondary-3 rounded px-3 row">
      <div
        class="col col-sm col-12 border-right d-flex justify-content-start justify-content-md-center align-items-center"
      >
        <div
          class="py-1 px-4 rounded-pill text-center font-14 font-weight-bold d-inline-block mt-2"
          :class="getPillBgClass(data.statusId)"
        >
          {{ data.status }}
        </div>
      </div>
      <div class="col col-sm col-12 pl-md-5 pt-3 pt-md-0">
        <span class="color-gray font-weight-normal font-14">
          Año Académico:
        </span>
        <div class="color-dark font-weight-normal font-16">
          {{ data.academicYear }}
        </div>
      </div>
      <div
        class="col col-sm col-12 pl-md-5 pt-3 pt-md-0"
        v-if="isStudentVisualImpairments"
      >
        <span class="color-gray font-weight-normal font-14">
          Porciento Completado:
        </span>
        <div class="color-dark font-weight-normal font-16">
          {{ data.percentage + ' %' }}
        </div>
      </div>
      <div class="col col-sm col-12 pt-3 pt-md-0">
        <span class="color-gray font-weight-normal font-14">
          Fecha de Sometido:
        </span>
        <div class="color-dark font-weight-normal font-16">
          {{ data.submittedDate | date }}
        </div>
      </div>
      <div class="col col-sm col-12 pt-3 pt-md-0">
        <span class="color-gray font-weight-normal font-14">Creado por:</span>
        <div class="color-dark font-weight-normal font-16">
          {{ data.createdBy }}
          <span class="color-gray">{{ data.creationDate | date }}</span>
        </div>
      </div>
      <div v-if="showUpdatedDate" class="col col-sm col-12 pt-3 pt-md-0">
        <span class="color-gray font-weight-normal font-14">
          &Uacute;ltima Modificaci&oacute;n:
        </span>
        <div class="color-dark font-weight-normal font-16">
          {{ data.updatedDate | date }}
        </div>
      </div>
      <div class="col col-sm col-12 text-right pt-3 pt-md-0 mt-1">
        <div v-if="actions.length" class="dropdown">
          <action-button
            class="btn btn-dropdown-actions dropdown-toggle pt-1"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Acciones
          </action-button>
          <div class="dropdown-menu dropdown-menu-right py-0">
            <action-button
              v-for="(action, key) in visibleActions"
              type="button"
              :key="key"
              :class="[
                'dropdown-item cursor-pointer text-left border-bottom py-2',
                action.variant,
              ]"
              :i="action.icon"
              :class-icon="action.classIcon"
              :text="action.text"
              @click="action.click(data)"
            />
          </div>
        </div>
        <div v-else>
          <action-button
            v-if="hasPublishDataAction"
            i="fa fa-upload"
            text="Publicar Datos"
            variant="success btn-block-xs-only mr-2"
            @click="$emit('on-publish-data')"
          />
          <action-button
            i="fas fa-file-import"
            text="Entrar"
            variant="outline-success btn-block-xs-only"
            @click="$emit('on-enter')"
          />
        </div>
      </div>

      <slot name="submission" :data="data"></slot>
    </div>
    <div class="row" v-if="data.showSubmitErrorMessage">
      <error
        class="error-message col"
        :message="
          'Para someter el reporte es necesario que el porcentaje de completado sea 100%'
        "
      />
    </div>
    
    <!-- Slot para contenido expandible adicional (ej: historial) -->
    <slot name="expandablehistory" :data="data"></slot>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import edenTypes from '@/utils/constants/edenTypes.js';
import Error from '@/components/common/Error';
import { resolveStatusColor } from '@/views/eden/shared/components/utils.js';

export default {
  name: 'EdenMasterSearchRow',
  components: {
    ActionButton,
    Error,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    hasPublishDataAction: {
      type: Boolean,
      default: () => false,
    },
    actions: {
      type: Array,
      default: () => [],
    },
    showUpdatedDate: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    getPillBgClass() {
      return (statusId) => resolveStatusColor(statusId); 
    },
    visibleActions() {
      return this.actions.filter((x) =>
        typeof x.visible === 'function'
          ? x.visible(this.data)
          : x.visible !== false
      );
    },
    isStudentVisualImpairments() {
      return this.data.edenReportType === edenTypes.StudenVisualImpairments;
    },
  },
};
</script>
<style scoped>
.ab-btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
.ab-btn:hover {
  color: #212529;
  text-decoration: none;
}
.dropdown-item:hover,
.dropdown-item:focus {
  color: #16181b;
  text-decoration: none;
  background-color: #e9ecef;
}
.ab-btn:focus,
.ab-btn.focus {
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(45, 183, 130, 0.25);
  box-shadow: 0 0 0 0.2rem rgba(45, 183, 130, 0.25);
}
.ab-btn {
  color: #212529;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  -webkit-transition: color 0.15s ease-in-out,
    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}
.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.error-message {
  margin: 0px;
}
</style>
